import {Injectable} from '@angular/core';
import {CameraService} from './camera.service';
import {CameraConstraintService} from './camera-constraint.service';
import {Subject} from 'rxjs/Subject';

declare const THREE: any;

interface IRadiusChangeEvent {
  radius: number;
}

@Injectable()
export class OrbitService {

  controls: any;
  public readonly onRadiusChange = new Subject<IRadiusChangeEvent>();
  private _enableZoom: boolean;
  public readonly maxDistance = 1500;
  public readonly minDistance = 400;

  constructor(
    protected cameraManager: CameraService,
    private cameraConstraintSrvc: CameraConstraintService
  ) {
  }

  init(canvas: HTMLCanvasElement) {
    const camera = this.cameraManager.perspective;
    camera.updateMatrixWorld();
    this.controls = new THREE.OrbitControls(camera, canvas);
    this.controls.minDistance = this.minDistance;
    this.controls.maxDistance = this.maxDistance;
    this.controls.maxPolarAngle = THREE.Math.degToRad(80);
    this.controls.enableZoom = this._enableZoom;
    this.setTarget(new THREE.Vector3(0, 1, 0));
    this.controls.canUpdate = this.cameraConstraintSrvc.validate.bind(this.cameraConstraintSrvc);
    this.controls.addEventListener('radiusChange', e => {
      this.onRadiusChange.next(e);
    });
  }

  enable() {
    this.controls.enabled = true;
  }

  disable() {
    this.controls.enabled = false;
  }

  setTarget(position) {
    this.controls.target.copy(position);
    this.controls.update();
  }

  update() {
    this.controls.update();
  }

  pan(x, y) {
    this.controls.pan(x, y);
    this.controls.update();
  }

  reset() {
    this.controls.reset();
    this.update();
  }

  set enableZoom(enable: boolean) {
    if (this.controls) {
      this.controls.enableZoom = enable;
    }
    this._enableZoom = enable;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/orbit.service.ts